import React, { createContext, useContext, useState } from "react";

const LanguageContext = createContext();

export const translations = {
  fr: {
    introduction: "Introduction",
    prerequis: "PREREQUIS",
    accountAccess: "Compte & accès",
    paymentApi: "API de paiement",
    paymentStatus: "Statut de paiement",
    transfertApi: "API de reversement",
    clientTransfer: "Reversement client",
  },
  en: {
    introduction: "Introduction",
    prerequis: "PREREQUISITES",
    accountAccess: "Account & access",
    paymentApi: "Payment API",
    paymentStatus: "Payment status",
    transfertApi: "Transfer API",
    clientTransfer: "Client transfer",
  },
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("fr");

  const toggleLanguage = () => {
    setLanguage((prev) => (prev === "fr" ? "en" : "fr"));
  };

  const t = (key) => translations[language][key] || key;

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};
